<script>
import DOMUtils from '@/utils/DOMUtils.js'
import TouchUtils from '@/utils/touchUtils'
import ImageEnlarger from '@/components/ImageEnlarger'

export default
{
    name: 'scrollable-content',

    props:
    {
        backgroundImage: { type: String, required: true },
        iconItems: {},
        backPath: { type: String, required: true },
        showBackIcon: { type: Boolean, default: true }
    },

    created ()
    {

    },

    render () 
    {
        return (
            <div id='scrollable-content-view' style={{ 'background-image': `url(${this.backgroundImage})` }}>
                <div id='backgroud-image-filter' ref='backgroundFilter'>
                    <div id='icons-bar' ref='iconsBar'>
                        {
                            this.showBackIcon &&
                                <inline-svg fill='white' src={require('@/assets/img/left-arrow.svg')} 
                                    on-click={() => this.$router.push(this.backPath)} id='back-icon' />
                        }
                        { this.iconItems }
                    </div>

                    <div id='scrollable-card' ref='scrollableCard'>
                        <inline-svg id='separator' src={require('@/assets/img/separator.svg')} />
                        <div id='content'>
                            <div id='card-text'>{ this.$slots.default }</div>
                        </div>
                    </div>
                </div>

                <image-enlarger ref='imageEnlarger' />
            </div>
        )
    },

    mounted ()
    {
        this.$refs.backgroundFilter.addEventListener('touchmove', this.cardOverscrollRoutine, { passive: true })
        this.$refs.backgroundFilter.addEventListener('touchend', this.onTouchEnd, { passive: true })
        this.$refs.backgroundFilter.addEventListener('touchend', this.cardOverscrollRoutine, { passive: true })

        this.$refs.scrollableCard.addEventListener('click', this.onscrollableCardClicked)

        let scrollableCard = this.$refs.scrollableCard
        if (scrollableCard == undefined) return
            
        DOMUtils.animateCSS(scrollableCard, 'fadeInUp', '0.5s', () =>
        {
            const routeHashes = window.location.href.split('#').splice(2)
            if (routeHashes[0])
            {
                const elem = this.$el.querySelector('#' + routeHashes[0])
                if (elem) elem.scrollIntoView({behavior: 'smooth'})
            }
        })
    },

    updated ()
    {
        DOMUtils.invertTextColorsIfNeeded(this.$refs.scrollableCard)
    },

    data () 
    {
        return {
            hideMainMenu: true,
            cardScrolledDownPercent: 0,
            hasCardBeenOverscrolledDown: false,
        }
    },

    computed:
    {
    },

    beforeDestroy ()
    {
        this.$refs.backgroundFilter.removeEventListener('touchmove', this.cardOverscrollRoutine)
        this.$refs.backgroundFilter.removeEventListener('touchend', this.onTouchEnd)
        this.$refs.backgroundFilter.removeEventListener('touchend', this.cardOverscrollRoutine)
    },

    watch:
    {
    },

    methods:
    {
        getCardScrolledDownPercent ()
        {
            const scrollableCard = this.$refs.scrollableCard
            const scrollTopPos = scrollableCard.getBoundingClientRect().top
            
            return Math.round(scrollTopPos / window.screen.height * 100)
        },

        cardOverscrollRoutine ()
        {
            if (this.hasCardBeenOverscrolledDown) return

            const scrollableCard = this.$refs.scrollableCard
            // force redraw
            scrollableCard.style.zIndex *= -1
            const scrollableCardDownScrolledPercent = this.getCardScrolledDownPercent()

            if (scrollableCardDownScrolledPercent < 0) return

            if (TouchUtils.currentTouchDelta.y >= 0 && scrollableCardDownScrolledPercent >= 60)
            {
                const overscrollResistance = 2
                scrollableCard.style.transform = `translateY(${TouchUtils.currentTouchDelta.y / overscrollResistance}px)`
            }
        },

        onTouchEnd ()
        {
            const cardScrolledDownPercent = this.getCardScrolledDownPercent()

            if (cardScrolledDownPercent >= 75)
            {
                this.hasCardBeenOverscrolledDown = true
                
                return this.$router.push(this.backPath)
            }

            // this should take effect after scroll momentum is gone
            const showBackButton = () =>
            {
                if (!this.$refs.scrollableCard) return
            }
            setTimeout(showBackButton, 200)
            setTimeout(showBackButton, 500)
            setTimeout(showBackButton, 1000)
            setTimeout(showBackButton, 2000)
        },

        onscrollableCardClicked (e)
        {
            if (e.target instanceof HTMLImageElement) this.onContentImageClicked (e.target)
        },

        /** 
         * @param imageElement {HTMLImageElement}
         */
        onContentImageClicked (imageElement)
        {
            this.$refs.imageEnlarger.enlargeImage(imageElement.src)
        }
    },

    components:
    {
        ImageEnlarger
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#scrollable-content-view
{
    height: 100vh;
    margin-bottom: -4vh;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-attachment: fixed;

    #backgroud-image-filter
    {
        width: 100%;
        height: 100%;
        background: linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.2));
        position: absolute;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        z-index: 0;

        #icons-bar
        {
            position: fixed;
            display: flex;
            width: -webkit-fill-available;
            margin: 0 4vw;
            justify-content: space-between;
            flex-direction: row;
            filter: drop-shadow(3px 3px 2px rgba(0, 0, 0, .4));
            z-index: -1;
            height: 4vh;
            margin-top: 8vh;

            #back-icon
            {
                left: 4vw;
                height: 100%;
                cursor: pointer;
            }

            #heart
            {
                right: 4vw;
                height: 100%;
                cursor: pointer;
                fill: white;

                &.active
                {
                    .border, .inside
                    {
                        fill: var(--theme-love-color);
                    }
                }
            }
        }

        #scrollable-card
        {
            position: relative;
            z-index: 2;
            background-color: var(--theme-content-background-color);
            border-radius: 30px 30px 0 0;
            margin-top: 60vh;
            min-height: 40vh;
            
            // to make sure there is no slick space between bottom of the card and bottom of the viewport 
            margin-bottom: -2px;

            .OnDesktop({
                max-width: 60%;
                margin-left: auto;
                margin-right: auto;
                border-radius: 12px 12px 0 0;
                box-shadow: 4px 4px 14px 0 rgba(80,94,120,.08);
            });

            #separator
            {
                @width: 15%;
                width: @width;
                margin-left: (100% - @width) / 2;
                transform: scaleY(0.7);
                fill: var(--theme-border-color-extra-strong);

                .OnTablet({
                    margin-top: 10px;
                });

                .OnDesktop({
                    display: none;
                });
            }

            #content
            {
                align-self: flex-end;
                padding: 6% 4% 10% 4%;
                overflow-wrap: break-word;

                .OnTablet({
                    padding-left: 12%;
                    padding-right: 12%;
                });
                
                .OnDesktop({
                    padding: 10% 15% 2% 15%;    
                });

                #card-text
                {
                    color: var(--theme-text-color-light);
                    font-family: Nunito;
                    font-size: 5vw;
                    font-weight: 500;
                    display: block;

                    .OnTablet({
                        font-size: 3vw;
                    });
                    
                    .OnDesktop({
                        font-size: 1vw;
                    });

                    .CapitalizeFirstLetter();

                    #title
                    {
                        color: var(--theme-text-color-dark);
                        font-family: Nunito;
                        font-weight: 800;
                        font-size: 6vw;
                        display: block;
                        margin-bottom: 20px;

                        .OnTablet({
                            font-size: 4vw;    
                        });
                        
                        .OnDesktop({
                            font-size: 2vw;    
                        });

                        .CapitalizeFirstLetter();
                    }

                    img
                    {
                        max-width: 100%;
                        cursor: pointer;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/ScrollableContent.vue